import React from 'react'
import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Slide,
  Typography
} from '@material-ui/core'
import { useStyles } from '../DashboardUserMessage/Styles'
import { NamedRoutes } from '../../../routes'
import Configuration from '../../../Services/Api/Configuration'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

// Module-level so it survives route changes (companies list isn't re-fetched on return) but resets on page refresh
let isDelegateEditDialogShown = false

const DashboardDelegateEditDialog = ({ userCompanies }) => {
  const classes = useStyles()
  const [openDialog, setOpenDialog] = React.useState(false)
  const { title, message } = Configuration.DELEGATE_EDIT_MESSAGE()

  React.useEffect(() => {
      if (!isDelegateEditDialogShown && !!userCompanies?.length && !!userCompanies[0]?.needs_delegate_edit) {
        isDelegateEditDialogShown = true
        setOpenDialog(true)
      }
    }, [userCompanies])

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  return (
    <Dialog
      fullWidth
      maxWidth={'md'}
      disableEscapeKeyDown
      disableBackdropClick
      open={openDialog}
      classes={{ paper: classes.NewOrderDialogPaper }}
      TransitionComponent={Transition}
      onClose={handleCloseDialog}
      aria-labelledby="DelegateEditDialog"
      aria-describedby="DelegateEditDialog"
    >
      <DialogTitle disableTypography className={classes.NewOrderDialogHeader}>
        <Typography variant="h5"><FormattedMessage id='delegateEditPopup.Title'/></Typography>
      </DialogTitle>
      <DialogContent className={classes.NewOrderDialogContent}>
        <Box py={2} px={4} className={classes.NewOrderStepsWrapper}>
          {!!title && <strong>{title}</strong>}
          {!!message && <p>{message}</p>}
          <NavLink to={NamedRoutes.workspace.einvoiceDelegates} onClick={handleCloseDialog}>
            <FormattedMessage id='delegateEditPopup.Link'/>
          </NavLink>
        </Box>
      </DialogContent>
      <DialogActions className={classes.NewOrderDialogFooter} style={{ justifyContent: 'flex-end' }}>
        <Button variant={'contained'} size={'large'} color={'primary'} onClick={handleCloseDialog}>
          <FormattedMessage id='PaymentOrder.ActionLinks.close'/>
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DashboardDelegateEditDialog
